import { useAppStore } from '@/lib/store';
import { WelcomeScreen } from '@/components/WelcomeScreen';
import { ClothingSelector } from '@/components/ClothingSelector';
import { ReferenceSelector } from '@/components/ReferenceSelector';
import { CameraCapture } from '@/components/CameraCapture';
import { CaptureSession } from '@/components/CaptureSession';
import { PhotoReview } from '@/components/PhotoReview';
import { ProcessingScreen } from '@/components/ProcessingScreen';
import { SidePhotoPrompt } from '@/components/SidePhotoPrompt';
import { ResultsScreen } from '@/components/ResultsScreen';
import { RotationCapture } from '@/components/RotationCapture';

function StepPlaceholder({ name }: { name: string }) {
  const setStep = useAppStore((s) => s.setStep);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6">
      <h2 className="mb-4 text-2xl font-bold text-gray-900">{name}</h2>
      <p className="mb-6 text-gray-500">Coming in Phase 2</p>
      <button
        onClick={() => setStep('welcome')}
        className="rounded-lg bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300"
      >
        Back to Start
      </button>
    </div>
  );
}

export default function App() {
  const currentStep = useAppStore((s) => s.currentStep);

  switch (currentStep) {
    case 'welcome':
      return <WelcomeScreen />;
    case 'clothing':
      return <ClothingSelector />;
    case 'reference':
      return <ReferenceSelector />;
    case 'capture_session':
      return <CaptureSession />;
    case 'photo_review':
      return <PhotoReview />;
    case 'capture_front':
      return <CameraCapture captureType="front" />;
    case 'capture_side':
      return <CameraCapture captureType="side" />;
    case 'capture_rotation':
      return <RotationCapture />;
    case 'processing':
      return <ProcessingScreen />;
    case 'side_prompt':
      return <SidePhotoPrompt />;
    case 'processing_side':
      return <ProcessingScreen />;
    case 'processing_rotation':
      return <ProcessingScreen />;
    case 'results':
      return <ResultsScreen />;
    case 'garment_select':
      return <StepPlaceholder name="Select Garments" />;
    case 'garment_results':
      return <StepPlaceholder name="Garment Results" />;
    default:
      return <WelcomeScreen />;
  }
}
